import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import styled from '@emotion/styled';
import { TopToScrollButtonZIndex } from '@/constant/z-index';

const LayoutLoading = () => {
  return (
    <UploadingLayout>
      <CircularProgress />
    </UploadingLayout>
  );
};
export default LayoutLoading;

const UploadingLayout = styled(Box)(({ theme }) => ({
  zIndex: TopToScrollButtonZIndex + 1,
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
}));
